import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { TraitSide } from '../Contexts/ConstantsCollection.js';
import { useAction } from '../Contexts/CharacterActions.js';

const TraitButton = ({ disabled, trait, traitSide }) => {
  const { triggerRollTrait } = useAction();
  const hoverBgColor =
    traitSide === TraitSide.Left
      ? 'leftSide.500'
      : traitSide === TraitSide.Right
      ? 'rightSide.500'
      : 'rgba(0, 0, 0, .1)';
  const hoverTxtColor = traitSide === TraitSide.Center ? 'black' : 'white';
  const placement = traitSide === TraitSide.Center ? 'top' : 'bottom';

  return (
    <Popover
      trigger="hover"
      openDelay={1000}
      closeDelay={150}
      placement={placement}
    >
      <PopoverTrigger>
        <div>
          <Button
            variant="ghost"
            _hover={{ bg: hoverBgColor, color: hoverTxtColor }}
            onClick={() => triggerRollTrait(trait.name)}
            isDisabled={disabled}
            sx={{
              _disabled: {
                cursor: 'default',
                _hover: { bg: 'initial', color: 'initial' },
              },
            }}
          >
            {trait.name}
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody textAlign="center" fontSize="10pt">
          <Link to={`/rules#` + trait.link}>{trait.summary}</Link>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default TraitButton;
